import { PressEvent } from '@react-types/shared/src/events'
import { Chip } from 'components/Chip/Chip'
import { Feedback } from 'types'
import Styles from './ContentRating.module.scss'
import { ChevronDown, ChevronUp } from 'blaze-ui/icons'
import cx from 'classnames'

export interface FeedbackChipProps {
  feedback: Feedback
  onChipPress: (e: PressEvent) => void
  onOtherPress: () => void
  showMore?: boolean
  setShowMore: (showMore: boolean) => void
}

export const FeedbackChips = ({ feedback, onChipPress, onOtherPress, showMore, setShowMore }: FeedbackChipProps) => {
  return (
    <div className={Styles.chips}>
      <Chip
        variant="flat"
        size="sm"
        deletable={false}
        key="image"
        data-key="image"
        onPress={onChipPress}
        className={Styles.chip}
        isSelected={feedback.feedback?.['image']}
      >
        Image
      </Chip>
      <Chip
        variant="flat"
        size="sm"
        deletable={false}
        key="wrong_language"
        data-key="wrong_language"
        onPress={onChipPress}
        className={Styles.chip}
        isSelected={feedback.feedback?.['wrong_language']}
      >
        Wrong language
      </Chip>
      <Chip
        variant="flat"
        size="sm"
        deletable={false}
        key="amount_of_text"
        data-key="amount_of_text"
        onPress={onChipPress}
        className={Styles.chip}
        isSelected={feedback.feedback?.['amount_of_text']}
      >
        Amount of text
      </Chip>
      <Chip
        variant="flat"
        size="sm"
        deletable={false}
        key="caption_text"
        data-key="caption_text"
        onPress={onChipPress}
        className={Styles.chip}
        isSelected={feedback.feedback?.['caption_text']}
      >
        Caption text
      </Chip>
      <Chip
        variant="flat"
        size="sm"
        deletable={false}
        key="layout"
        data-key="layout"
        onPress={onChipPress}
        className={Styles.chip}
        isSelected={feedback.feedback?.['layout']}
      >
        Layout
      </Chip>
      {showMore && (
        <>
          <Chip
            variant="flat"
            size="sm"
            deletable={false}
            key="writing_quality"
            data-key="writing_quality"
            onPress={onChipPress}
            className={Styles.chip}
            isSelected={feedback.feedback?.['writing_quality']}
          >
            Writing quality
          </Chip>
          <Chip
            variant="flat"
            size="sm"
            deletable={false}
            key="inaccurate"
            data-key="inaccurate"
            onPress={onChipPress}
            className={Styles.chip}
            isSelected={feedback.feedback?.['inaccurate']}
          >
            Inaccurate
          </Chip>
          <Chip
            variant="flat"
            size="sm"
            deletable={false}
            key="missing_text"
            data-key="missing_text"
            onPress={onChipPress}
            className={Styles.chip}
            isSelected={feedback.feedback?.['missing_text']}
          >
            Missing text
          </Chip>
          <Chip
            variant="flat"
            size="sm"
            deletable={false}
            key="colors_and_fonts"
            data-key="colors_and_fonts"
            onPress={onChipPress}
            className={Styles.chip}
            isSelected={feedback.feedback?.['colors_and_fonts']}
          >
            Colors and fonts
          </Chip>
        </>
      )}
      <Chip
        variant="flat"
        size="sm"
        deletable={false}
        key="other"
        data-key="other"
        onPress={onOtherPress}
        className={Styles.chip}
        isSelected={feedback.feedback?.['other']}
      >
        Other
      </Chip>
      <Chip
        variant="flat"
        size="sm"
        deletable={false}
        key="moreOrLess"
        data-key="moreOrLess"
        onPress={() => setShowMore(!showMore)}
        className={cx(Styles.chip, Styles.moreOrLessChip)}
        isSelected={false}
      >
        {showMore ? 'Less' : 'More'}
        {showMore ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
      </Chip>
    </div>
  )
}
